import actions from './actions'
import agentAvatar from '@/assets/image/avatar-agent.png'
import userAvatar from '@/assets/image/avatar-user-saas.png'
import useClipboard from 'vue-clipboard3'
import { Message } from 'element-ui'

const chatStore = {
  namespaced: true,
  state: {
    // 会话信息
    chatInfo: {
      // 负数为游客
      userId: Number(localStorage.getItem('userId')) || 0,
      // 微信openid
      openid: localStorage.getItem('openid'),
      userName: null,
      phone: null,
      appKey: null,
      // 会话id
      sessionId: null,
      // 会话场景标识，新id会覆盖旧的
      pageId: '',
      // 会话类型:0-默认, 1-进行中, 2-留言,3-待跟进
      dialogType: 0,
      // 渠道 1000-PC 1001-微信服务号 1002-微信H5 1003-APP
      sc: 1000,
      // yjj-1000 dy-1001 微信h5-1002 APP-1003
      appId: 1000,
      // 纬度
      latitude: null,
      // 经度
      longitude: null,
      userIp: null,
      // 1-普通接入(默认商城首页)、2-订单详情页,3-商详页、4-我的、5-店铺首页
      portalType: 1,
      // 订单号：portalType为2时必传
      orderNo: null,
      // 订单号：portalType为1101和1103时必传
      itemStoreId: null,
      // 页面过期
      pageExpired: false,
      // 会话关闭
      isClose: false,
      // 是否已加入客服
      isJoinKefu: false,
      // 商户id - pop使用
      merchantCode: null,
      // saas参数
      organSign: null,
      // 是否绑定CA客服
      hasCA: false,
      // ca客服id
      CAAgentId: null,
      // 客服二维码
      agentQR: null,
      // 1 代表android
      terminal: '',
      companyId: '',
      // 会话列表用-店铺id
      storeId: '',
      // 会话列表用-会话切换传userId传accountId
      accountId: '',
      // 会话列表用-组织id
      businessPartCode: '',
      // 会话列表用-PC端更新头像
      csAvatar: '',
      // 会话列表用-PC端更新名称
      csTitle: '',
      customerShowType: 1, // 1.正常 2.游客 3.灯塔
      customWebSocketSwitch: 0 // websocket开关 0.关闭 1.开启
    },
    // 用户ID
    uid: null,
    kefuid: null,
    userAvatar,
    // 客服默认头像
    agentAvatar,
    // quill实例
    quill: null,
    // 输入框原始消息
    inputContent: '',
    // 输入框文本消息
    inputText: '',
    // 最大可输入长度
    maxInputLen: 2000,
    // 当前会话消息
    currentChatMsgs: [],
    // 首屏初始化阶段暂存的当前会话消息(message/history)
    initCurrentHistoryMsgs: [],
    initCurrentHistoryResolved: false,
    // 首屏初始化阶段暂存的实时消息
    initPendingChatMsgs: [],
    // 首屏是否处于三路消息合并阶段
    isInitMergingMsgs: false,
    // 首屏初始化阶段当前入栈消息来源
    initMsgSource: '',
    // 预览大图的地址
    previewImgList: [],
    // 是否正在发送消息中
    isSending: false,
    // 是否正在上传文件
    isUploading: false,
    // 满意度评价队列，新老会话都需要评价
    estimationTasks: [],
    // 当前评价会话id
    estimationSessionId: null,
    // ev前缀表示事件
    evSendInput: 0,
    // 消息列表滚动到底部
    evScrollToBottom: 0,
    // 满意度评价
    evEstimation: 0,
    // 关闭图片浏览器
    evCloseImgView: 0,
    // 显示pdf预览弹窗
    fileDialogVisible: false,
    // 文件信息
    fileInfo: {
      src: '',
      type: '',
      name: ''
    },
    // 是否加载历史消息
    isLoadHistoryMsg: false,
    // 切换会话加载loading
    evChatLoading: 0,
    // 切换会话清除加载loading
    evChatLoadingClose: 0,
    // 没有会话选中，展示缺省图
    assignChatItemSelected: true,
    // 页面刷新新增传参
    refreshFlag: false,
    // 连续刷新调接口加载，根据341参数停止轮询调接口
    refreshIndexInit: true,
    // 上传文件加载loading
    evChatInputLoading: 0,
    evChatInputLoadingClose: 0,
    // 如果是消息类型421，重新加载会话时，判断是否重新加载beforeDialog接口，// 消息类型为422时，重新加载会话，不用加载beforeDialog接口
    isReloadConversation: 0,
    // 问答数组
    qaList: [],
    // 问答问答数据缓存
    questionCache: {},
    // 关闭订单弹框
    evCloseOrder: 0,
    // 问答兜底
    backstopObj: {},
    // 自助查询
    selfServiceObj: {},
    // 自助查询-订单无发票
    noInvoiceObj: {},
    // app-自助查询订单
    evAppSelfServiceOrder: 0,
    // app-自助查询客户
    evAppConsultCustomer: 0,
    // app-自助查询灯塔订单
    evAppLighthouseOrder: 0,
    // 邀评id
    evaluationDialogid: '',
    // 只在初始化第一次加载会话列表判断
    nonChatlist: false,
    // 会话列表标识
    evEventChatList: 0,
    // 会话列表
    userDialogList: [],
    // websocket
    wsService: null,
    // 正常消息
    evEventMessage: 0,
    // 正在输入
    evEventTyping: 0,
    // 新消息
    formatMsg: {},
    // 是否首次加载会话
    isFirstScroll: true,

    aiMsgData: {
      // Ai流式会话对象, 谨慎
      returnRenderTxtList: [],
      index: 0,
      formatText: '',
      streamEnd: false,
      startTime: Date.now(),
      renderText: '',
      setRenderText: '',
      timer: null,
      endTimer: null
    },
    thinkLoading: false,
    aiEvent: '', // ai事件
    isAiMsgOpen: false, // 获取户端ai开关
    conversationId: '',
    taskId: '',
    fetchAiMessageId: new Date().getTime(), // ai messageId
    streamingFlag: false // 流式会话整体流程，控制重复
  },
  mutations: {
    updateFetchAiMessageId(state, id) {
      state.fetchAiMessageId = id
    },
    updateStreamingFlag(state, flag) {
      state.streamingFlag = flag
    },
    updateThinkLoading(state, flag) {
      state.thinkLoading = flag
    },
    updateAiEvent(state, event) {
      state.aiEvent = event
    },
    updateConversationId(state, id) {
      state.conversationId = id
    },
    updateTaskId(state, id) {
      state.taskId = id
    },
    updateIsAiMsgOpen(state, data) {
      state.isAiMsgOpen = data
    },
    updateAiMsgData(state, data) {
      state.aiMsgData = {
        ...state.aiMsgData,
        ...data
      }
    },
    updateChatInfo(state, data) {
      state.chatInfo = {
        ...state.chatInfo,
        ...data
      }
      if (data.userId) {
        // userId需要存本地
        localStorage.setItem('userId', String(data.userId))
      }
      if (data.openid) {
        // openid需要存本地
        localStorage.setItem('openid', String(data.openid))
      }
    },
    updateUid(state, uid) {
      state.uid = uid
    },
    updateKefuid(state, kefuid) {
      state.kefuid = kefuid
    },
    updateUserAvatar(state, src) {
      src && (state.userAvatar = src)
    },
    updateAgentAvatar(state, src) {
      src && (state.agentAvatar = src)
    },
    setQuill(state, quill) {
      state.quill = quill
    },
    updateQuillContent(state, data) {
      state.inputContent = data.content
      state.inputText = data.text
    },
    updateMaxInputLen(state, maxLen = 2000) {
      state.maxInputLen = maxLen
    },
    setCurrentChatMsgs(state, arr = []) {
      // 初始化当前会话消息
      state.currentChatMsgs = arr
    },
    setInitCurrentHistoryMsgs(state, arr = []) {
      state.initCurrentHistoryMsgs = arr
    },
    setInitCurrentHistoryResolved(state, resolved = false) {
      state.initCurrentHistoryResolved = resolved
    },
    setInitPendingChatMsgs(state, arr = []) {
      state.initPendingChatMsgs = arr
    },
    pushCurrentChatMsgs(state, arr) {
      // 推送当前会话消息
      state.currentChatMsgs.push(...arr)
    },
    pushInitPendingChatMsgs(state, arr) {
      const exists = new Set(
        [...state.initCurrentHistoryMsgs, ...state.initPendingChatMsgs]
          .map(msg => msg && (msg.msgId || msg.messageId))
          .filter(Boolean)
      )

      const nextMsgs = arr.filter(msg => {
        const key = msg && (msg.msgId || msg.messageId)
        if (!key) return true
        if (exists.has(key)) return false
        exists.add(key)
        return true
      })

      state.initPendingChatMsgs.push(...nextMsgs)
    },
    pushInitCurrentHistoryMsgs(state, arr) {
      const exists = new Set(
        [...state.initCurrentHistoryMsgs, ...state.initPendingChatMsgs]
          .map(msg => msg && (msg.msgId || msg.messageId))
          .filter(Boolean)
      )

      const nextMsgs = arr.filter(msg => {
        const key = msg && (msg.msgId || msg.messageId)
        if (!key) return true
        if (exists.has(key)) return false
        exists.add(key)
        return true
      })

      state.initCurrentHistoryMsgs.push(...nextMsgs)
    },
    insertCurrentChatMsgs(state, arr) {
      // 在头部插入会话消息
      state.currentChatMsgs.unshift(...arr)
    },
    SET_INIT_MERGING_MSGS(state, flag) {
      state.isInitMergingMsgs = flag
    },
    setInitMsgSource(state, source = '') {
      state.initMsgSource = source
    },
    setPreviewImgList(state, list) {
      state.previewImgList = list
    },
    setIsSending(state, isSending) {
      state.isSending = isSending
    },
    setIsUploading(state, isUploading) {
      state.isUploading = isUploading
    },
    pushEstimationTasks(state, sessionId) {
      if (!state.estimationTasks.includes(sessionId)) {
        state.estimationTasks.push({ id: sessionId, finished: false })
      }
    },
    finishEstimationTask(state) {
      // 完成当前评价
      const task = state.estimationTasks.find(task => task.id === state.estimationSessionId)
      if (task) {
        task.finished = true
      }
    },
    updateEstimationSessionId(state, sessionId) {
      state.estimationSessionId = sessionId
    },
    updateFileDialogVisible(state) {
      state.fileDialogVisible = !state.fileDialogVisible
    },
    setFileInfo(state, obj) {
      state.fileInfo = {
        ...state.fileInfo,
        ...obj
      }
    },
    // 通用事件触发器
    emit(state, evName) {
      state[evName]++
    },
    SET_NONCHATLIST: (state, nonChatlist) => {
      state.nonChatlist = nonChatlist
    },
    SET_LOADHISTORYMSG: (state, isLoadHistoryMsg) => {
      state.isLoadHistoryMsg = isLoadHistoryMsg
    },
    evChatLoadingClose(state, evName) {
      state[evName]++
    },
    setAssignChatItemSelected: (state, assignChatItemSelected) => {
      state.assignChatItemSelected = assignChatItemSelected
    },
    setRefreshFlag(state, refreshFlag) {
      state.refreshFlag = refreshFlag
    },
    setRefreshIndexInit(state, refreshIndexInit) {
      state.refreshIndexInit = refreshIndexInit
    },
    copy(state, text) {
      const { toClipboard } = useClipboard()
      toClipboard(text)
      Message.success('复制成功')
    },
    setReloadConversation: (state, isReloadConversation) => {
      state.isReloadConversation = isReloadConversation
    },
    setQaList: (state, qaList) => {
      state.qaList = qaList
    },
    setQuestionCache(state, { msgId, startIndex, qaList }) {
      // 根据问答问题项的ID存储数据
      state.questionCache[msgId] = { startIndex, qaList }
    },
    setBackstopObj(state, backstopObj) {
      // 根据问答问题项的ID存储数据
      state.backstopObj = backstopObj
    },
    setSelfServiceObj(state, selfServiceObj) {
      // 自助查询问题项
      state.selfServiceObj = selfServiceObj
    },
    setEvaluationDialogid(state, dialogid) {
      state.evaluationDialogid = dialogid
    },
    setWsService(state, wsService) {
      state.wsService = wsService
    },
    addMessageTask(state, { requestId, resolve, reject }) {
      state.wsService.messageQueue[requestId] = { requestId, resolve, reject }
    },
    setFormatReceiveMsg(state, message) {
      state.formatMsg = message
    },
    setUserDialogList(state, userDialogList) {
      state.userDialogList = userDialogList
    },
    evEventChat(state, evName) {
      state[evName]++
    },
    SET_FIRSTSCROLL: (state, isFirstScroll) => {
      state.isFirstScroll = isFirstScroll
    }
  },
  getters: {
    restInputLen(state) {
      // 剩余可输入长度
      // quill文本结尾会默认带一个换行符
      const text = state.inputText.replace(/\n$/, '')
      return state.maxInputLen - text.length
    },
    isVisitor(state) {
      // 负数为游客
      return !state.chatInfo.userId || state.chatInfo.userId < 0
    },
    isPc(state) {
      return state.chatInfo.appId == 1000 || state.chatInfo.sc == 1000
    },
    isWXH5(state) {
      return state.chatInfo.sc == 1002 || state.chatInfo.sc == 1007 || state.chatInfo.appId == 1002
    },
    isYJJApp(state) {
      return state.chatInfo.sc == 1003 || state.chatInfo.appId == 1003
    },
    isCustomWebSocketSwitch: state => {
      return state.chatInfo.customWebSocketSwitch === 1
    }
  },
  actions
}

export default chatStore
